import { useState } from 'react';
import { ChartEditModal } from './ChartEditModal';
import Button from '@splunk/react-ui/Button';
import Pencil from '@splunk/react-icons/Pencil';

export type ChartPageHeaderEditProps = {
    description?: string;
    name?: string;
    update: (params: { name?: string; description?: string }) => void;
};

export const ChartPageHeaderEdit = ({
    description,
    name,
    update: rawUpdate,
}: ChartPageHeaderEditProps): JSX.Element => {
    const [open, setOpen] = useState(false);

    const handleRequestClose = (): void => {
        setOpen(false);
    };

    const update = ({ name, description }: { name?: string; description?: string }): void => {
        setOpen(false);
        rawUpdate({ name, description });
    };

    return (
        <>
            <Button
                appearance="secondary"
                icon={<Pencil />}
                onClick={(): void => {
                    setOpen(!open);
                }}
            />

            <ChartEditModal
                name={name}
                description={description}
                handleRequestClose={handleRequestClose}
                open={open}
                update={update}
            />
        </>
    );
};
